import ColorFlatUI from '../core/tools/colorflatui';
import environment from '../environment';
import Leaflet from './Leaflet';

class MarkedAreaAdditionalLayer {
    constructor (currentMap) {
        const layer = new Leaflet.D3Layer();

        layer.setOptions({
            map: currentMap,
            remote: {
                url: `${environment.get('API_HOST')}/localidade/GetLocation`,
                params: {
                    locationType: 0
                }
            },
            cache: true,
            filter: {
                location: true
            },
            scaleRange: [4, 18],
            showAll: false,
            expandView: 0.5,
            autofocus: false,
            uniqueField: 'Id',
            sort: 'Nome',
            above: true,
            symbology: {
                type: 'single',
                style: {
                    lineJoin: 'round',
                    color: ColorFlatUI.asbestos[1][0],
                    fillColor: 'none',
                    opacity: 1,
                    weight: 3
                }
            }
        });

        return layer;
    }
}

export default MarkedAreaAdditionalLayer;



// WEBPACK FOOTER //
// ./src/scripts/layers/MarkedAreaAdditionalLayer.js